import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, normalizeStyle as _normalizeStyle, createVNode as _createVNode, withModifiers as _withModifiers, withCtx as _withCtx, createTextVNode as _createTextVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, createBlock as _createBlock, normalizeClass as _normalizeClass, createStaticVNode as _createStaticVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue";
const _withScopeId = n => (_pushScopeId("data-v-e604271c"), n = n(), _popScopeId(), n);
const _hoisted_1 = {
  class: "df-table"
};
const _hoisted_2 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  class: "title"
}, "Product name", -1));
const _hoisted_3 = {
  class: "standard cogs-column",
  style: {
    "width": "367px"
  }
};
const _hoisted_4 = {
  class: "th end"
};
const _hoisted_5 = {
  class: "product-package-style",
  id: "tooltip-target-cogs"
};
const _hoisted_6 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("p", {
  class: "tooltip-title"
}, "COGS", -1));
const _hoisted_7 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("p", {
  class: "tooltip-description"
}, "Cost of Goods Sold. Used for product margin calculation, defining advertising bids, and the Profit & Loss module.", -1));
const _hoisted_8 = /*#__PURE__*/_createStaticVNode("<div class=\"sub-cells\" data-v-e604271c><div class=\"sub-cell\" style=\"width:32%;justify-content:flex-end;padding:8px;\" data-v-e604271c><div class=\"title\" data-v-e604271c>Cost</div></div><div class=\"sub-cell\" style=\"width:30.5%;\" data-v-e604271c><div class=\"title\" data-v-e604271c>Currency</div></div><div class=\"sub-cell\" style=\"width:37.5%;justify-content:flex-end;padding:8px;\" data-v-e604271c><div class=\"title\" data-v-e604271c>Last modified</div></div></div>", 1);
const _hoisted_9 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("th", {
  class: "standard",
  style: {
    "width": "136px"
  }
}, [/*#__PURE__*/_createElementVNode("div", {
  class: "th"
}, [/*#__PURE__*/_createElementVNode("div", {
  class: "title dark"
}, "Product Segment ")])], -1));
const _hoisted_10 = {
  class: "th"
};
const _hoisted_11 = {
  class: "title dark",
  id: "tooltip-target-external-sku"
};
const _hoisted_12 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("p", {
  class: "tooltip-title"
}, "External SKU", -1));
const _hoisted_13 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("p", {
  class: "tooltip-description"
}, [/*#__PURE__*/_createElementVNode("i", null, "(Optional)"), /*#__PURE__*/_createTextVNode(" Your internal product ID, used for demand forecasting and accounting reports.")], -1));
const _hoisted_14 = {
  key: 0,
  class: "standard",
  style: {
    "width": "164px"
  }
};
const _hoisted_15 = {
  class: "th"
};
const _hoisted_16 = {
  class: "title dark",
  id: "tooltip-target-product-tax-code"
};
const _hoisted_17 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("p", {
  class: "tooltip-title"
}, "Product Tax Code", -1));
const _hoisted_18 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("p", {
  class: "tooltip-description"
}, [/*#__PURE__*/_createTextVNode("Used to compute revenue excluding tax for vendors in the EU."), /*#__PURE__*/_createElementVNode("a", {
  href: "https://sellercentral.amazon.com/tax/nexus/settings/ptc"
}, "Learn more about Amazon PTC")], -1));
const _hoisted_19 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("th", {
  class: "standard",
  style: {
    "width": "32px"
  }
}, null, -1));
export function render(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_app_icon = _resolveComponent("app-icon");
  const _component_b_popover = _resolveComponent("b-popover");
  const _component_cogs_data_row = _resolveComponent("cogs-data-row");
  return _openBlock(), _createElementBlock("div", {
    class: _normalizeClass(["df", {
      blur: $data.dataLoading
    }])
  }, [_createElementVNode("table", _hoisted_1, [_createElementVNode("thead", null, [_createElementVNode("tr", null, [_createElementVNode("th", {
    class: "standard",
    style: _normalizeStyle({
      width: $props.accountProvider === 'Amazon Vendor Central' ? '333px' : '668px'
    })
  }, [_createElementVNode("div", {
    class: "th sortable",
    onClick: _cache[0] || (_cache[0] = _withModifiers($event => $options.onSort('product_name'), ["stop"]))
  }, [_hoisted_2, _createVNode(_component_app_icon, {
    icon: `chevron-down2`,
    color: $props.sortField == 'product_name' ? '#5A52AE' : '#757575',
    style: _normalizeStyle(`transform: rotate(${$props.sortDirection == 'asc' ? 0 : 180}deg)`)
  }, null, 8, ["color", "style"])])], 4), _createElementVNode("th", _hoisted_3, [_createElementVNode("div", _hoisted_4, [_createElementVNode("div", _hoisted_5, [_createTextVNode("COGS "), _createVNode(_component_b_popover, {
    target: "tooltip-target-cogs",
    triggers: "hover",
    customClass: "cogs-data-tooltip-class wrap-with-popover"
  }, {
    default: _withCtx(() => [_hoisted_6, _hoisted_7]),
    _: 1
  })])]), _hoisted_8]), _hoisted_9, _createElementVNode("th", {
    class: "standard",
    style: _normalizeStyle([{
      "width": "136px"
    }, {
      width: $props.accountProvider === 'Amazon Vendor Central' ? '136px' : '272px'
    }])
  }, [_createElementVNode("div", _hoisted_10, [_createElementVNode("div", _hoisted_11, [_createTextVNode("External SKU "), _createVNode(_component_b_popover, {
    target: "tooltip-target-external-sku",
    triggers: "hover",
    customClass: "cogs-data-tooltip-class wrap-with-popover"
  }, {
    default: _withCtx(() => [_hoisted_12, _hoisted_13]),
    _: 1
  })])])], 4), $props.accountProvider === 'Amazon Vendor Central' ? (_openBlock(), _createElementBlock("th", _hoisted_14, [_createElementVNode("div", _hoisted_15, [_createElementVNode("div", _hoisted_16, [_createTextVNode("Product Tax Code "), _createVNode(_component_b_popover, {
    target: "tooltip-target-product-tax-code",
    triggers: "hover",
    customClass: "cogs-data-tooltip-class wrap-with-popover"
  }, {
    default: _withCtx(() => [_hoisted_17, _hoisted_18]),
    _: 1
  })])])])) : _createCommentVNode("", true), _hoisted_19])]), _createElementVNode("tbody", null, [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList($props.items, (item, index) => {
    return _openBlock(), _createBlock(_component_cogs_data_row, {
      key: `${index}`,
      uniqueIndex: index,
      item: item,
      productSegmentsList: $props.productSegmentsList,
      accountProvider: $props.accountProvider,
      focusedCell: $data.focusedCell,
      onUpdateFocusedCell: $options.setFocusedCell,
      onSelect: $options.onSelect,
      onUpdate: $options.onUpdate,
      onUpdateVendor: $options.onUpdateVendor,
      onExpiration: $options.onExpirationDateRequired
    }, null, 8, ["uniqueIndex", "item", "productSegmentsList", "accountProvider", "focusedCell", "onUpdateFocusedCell", "onSelect", "onUpdate", "onUpdateVendor", "onExpiration"]);
  }), 128))])])], 2);
}